<!-- @format -->

<div class="teaching-not-selected-container">
  <sis-expandable [variant]="'naked-dotted'" [closed]="isMobileView" [size]="'xl'">
    <ng-template sisExpandableCustomTitle>
      <span class="unscheduled-items-title">{{ "ENROLMENTS.UNSCHEDULED_COURSE_UNITS" | translate }}</span>
    </ng-template>
    <ng-template sisExpandableContent>
      @if (studyRights$ | async; as studyRights) {
        <label id="select-study-right" translate>ENROLMENTS.STUDY_RIGHT</label>
        @if (studyRights.length > 0) {
          <div class="col-sm-12 col-md-8 col-lg-6 col-xl-5">
            @if (studyRights.length > 1) {
              <ng-container [ngTemplateOutlet]="select"></ng-container>
            }
            @if (studyRights.length === 1) {
              <ng-container [ngTemplateOutlet]="view"></ng-container>
            }
          </div>
        }
        @if (studyRights.length === 0) {
          <sis-contextual-notification variant="warning" [content]="'ENROLMENTS.NO_STUDY_RIGHTS' | translate">
          </sis-contextual-notification>
        }
        <ng-template #select>
          <select
            class="form-select"
            [ngModel]="studyRight"
            (ngModelChange)="onStudyRightChange($event)"
            aria-labelledby="select-study-right"
            data-cy="select-study-right">
            <option [ngValue]="undefined" disabled selected>{{ "ENROLMENTS.STUDY_RIGHT_SELECT" | translate }}</option>
            @for (sr of studyRights; track sr) {
              <option [selected]="studyRight === sr" [ngValue]="sr"
                >{{ sr.educationId | education | async | entityName | localizedString }} ({{ "STUDY_RIGHT_STATE." + sr.state | translate }})
              </option>
            }
          </select>
        </ng-template>
        <ng-template #view>
          @if (studyRights.length === 1) {
            <p aria-labelledby="select-study-right">
              {{ studyRight.educationId | education | async | entityName | localizedString }}
              ({{ "STUDY_RIGHT_STATE." + studyRight.state | translate }})
            </p>
          }
        </ng-template>
      }

      @if ((education$ | async)?.studySelectionRequirement; as studySelectionRequirement) {
        @if (studySelectionRequirement === "UNRESTRICTED" || studySelectionRequirement === "SELECTION_REQUIRED") {
          <h3>{{ "ENROLMENTS.PRIMARY_PLAN_COURSE_UNITS_TITLE" | translate }}</h3>
          <p class="guidance">{{ "ENROLMENTS.PRIMARY_PLAN_COURSE_UNITS_CONTENT" | translate }}</p>
          <app-degree-studies-untimed
            [validatablePlan]="validatablePlan$ | async"
            [enrolmentsInCalendar]="enrolmentsInCalendar"></app-degree-studies-untimed>
        }
        @if (studySelectionRequirement === "ENROLMENT_RIGHT_REQUIRED") {
          <app-open-studies-untimed [studyRight]="studyRight"></app-open-studies-untimed>
        }
      }
    </ng-template>
  </sis-expandable>
</div>
